import { render, staticRenderFns } from "./promo_dashboard.vue?vue&type=template&id=2106abec&scoped=true"
import script from "./promo_dashboard.vue?vue&type=script&lang=js"
export * from "./promo_dashboard.vue?vue&type=script&lang=js"
import style0 from "./promo_dashboard.vue?vue&type=style&index=0&id=2106abec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106abec",
  null
  
)

export default component.exports